import React from 'react';
import { FiUsers, FiMapPin, FiTrendingUp } from 'react-icons/fi';
import { formatCurrency } from '../../utils/formatCurrency';
import './VehicleCard.css';

const VehicleCard = ({ vehicle, onSelect }) => {
  if (!vehicle) return null;
  const {
    vehicle_type,
    distance_km,
    per_km_price,
    total_price,
    available = true,
  } = vehicle;

  return (
    <div className={`vc-card ${!available ? 'unavailable' : ''}`}>
      <div className="vc-main">
        <div className="vc-icon" aria-hidden>🚕</div>
        <div className="vc-info">
          <h4 className="vc-type">{vehicle_type}</h4>
          <p className="vc-meta"><FiUsers /> Up to 4 passengers</p>
          {distance_km != null && (
            <p className="vc-meta"><FiMapPin /> {Number(distance_km).toFixed(2)} KM</p>
          )}
          {per_km_price != null && (
            <p className="vc-meta"><FiTrendingUp /> {formatCurrency(per_km_price)} / KM</p>
          )}
        </div>
      </div>
      <div className="vc-side">
        <span className="vc-fare-label">Estimated Fare</span>
        <strong className="vc-fare">{formatCurrency(total_price || 0)}</strong>
        <button
          className="vc-cta"
          disabled={!available}
          onClick={() => available && onSelect?.(vehicle)}
        >
          {available ? 'Select Cab' : 'Unavailable'}
        </button>
      </div>
    </div>
  );
};

export default VehicleCard;